import { render, staticRenderFns } from "./EducationExamsAddExam.vue?vue&type=template&id=1c6eda07&"
import script from "./EducationExamsAddExam.vue?vue&type=script&lang=js&"
export * from "./EducationExamsAddExam.vue?vue&type=script&lang=js&"
import style0 from "./EducationExamsAddExam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports